module.exports = global["Highcharts"] = require("-!/data/app/rdc-next/node_modules/source-map-loader/index.js!./highcharts.js");


//////////////////
// WEBPACK FOOTER
// /data/app/rdc-next/~/highcharts/highcharts.js
// module id = 108
// module chunks = 1 2 3 4 6 7 10 11